import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './StudentFeedback.css';
import API_URL from '../../api/ExamCalendarApi';

const StudentFeedbacks = () => {
    const [feedbacks, setFeedbacks] = useState([]);
    const [name, setName] = useState('');
    const [achievement, setAchievement] = useState('');
    const [feedbackText, setFeedbackText] = useState('');
    const [photo, setPhoto] = useState(null);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    const [currentFeedbackId, setCurrentFeedbackId] = useState(null);

    // Fetch feedbacks when the component mounts
    useEffect(() => {
        fetchFeedbacks();
    }, []);

    // Fetch all feedbacks
    const fetchFeedbacks = async () => {
        try {
            const response = await axios.get(`${API_URL}/homepage/feedbacks`);
            setFeedbacks(response.data.feedbacks);
        } catch (error) {
            console.error('Error fetching feedbacks:', error);
        }
    };

    // Handle form submission for create or update
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !feedbackText) {
            setError('Name and feedback text are required');
            return;
        }

        const formData = new FormData();
        formData.append('name', name);
        formData.append('achievement', achievement);
        formData.append('feedbackText', feedbackText);
        if (photo) formData.append('photo', photo);

        try {
            if (updateMode) {
                await axios.put(`${API_URL}/homepage/update-feedback/${currentFeedbackId}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                setSuccessMessage('Feedback updated successfully');
            } else {
                await axios.post(`${API_URL}/homepage/add-feedback`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
                setSuccessMessage('Feedback added successfully');
            }

            // Reset form and update the feedback list
            setName('');
            setAchievement('');
            setFeedbackText('');
            setPhoto(null);
            setUpdateMode(false);
            fetchFeedbacks();
        } catch (error) {
            setError('Error saving feedback');
            setSuccessMessage('');
        }
    };

    // Handle deleting a feedback
    const handleDelete = async (feedbackId) => {
        try {
            await axios.delete(`${API_URL}/homepage/delete-feedback/${feedbackId}`);
            setSuccessMessage('Feedback deleted successfully');
            fetchFeedbacks();
        } catch (error) {
            setError('Error deleting feedback');
        }
    };

    // Handle editing a feedback (populate form with current values)
    const handleEdit = (feedbackItem) => {
        setName(feedbackItem.name);
        setAchievement(feedbackItem.achievement);
        setFeedbackText(feedbackItem.feedbackText);
        setPhoto(null); // Optional: You can preload the photo URL if needed
        setCurrentFeedbackId(feedbackItem._id);
        setUpdateMode(true);
    };

    return (
        <div className="admin-studentfeedback-container">
            <h3 className="admin-studentfeedback-title">Student Feedbacks</h3>
            {error && <div className="admin-studentfeedback-alert error">{error}</div>}
            {successMessage && <div className="admin-studentfeedback-alert success">{successMessage}</div>}

            <form onSubmit={handleSubmit} className="admin-studentfeedback-form">
                <div className="admin-studentfeedback-form-group">
                    <label>Student Name</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </div>

                <div className="admin-studentfeedback-form-group">
                    <label>Achievement</label>
                    <input
                        type="text"
                        value={achievement}
                        onChange={(e) => setAchievement(e.target.value)}
                    />
                </div>

                <div className="admin-studentfeedback-form-group">
                    <label>Feedback</label>
                    <input
                        type="text"
                        value={feedbackText}
                        onChange={(e) => setFeedbackText(e.target.value)}
                        required
                    />
                </div>

                <div className="admin-studentfeedback-form-group">
                    <label>Upload Photo</label>
                    <input
                        type="file"
                        onChange={(e) => setPhoto(e.target.files[0])}
                    />
                </div>

                <button type="submit" className="admin-studentfeedback-button">
                    {updateMode ? 'Update' : 'Add'} Feedback
                </button>
            </form>

            <h3 className="admin-studentfeedback-title">Feedback List</h3>
            <div className="admin-studentfeedback-table-wrapper">
            <table className="admin-studentfeedback-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Achievement</th>
                        <th>Feedback</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {feedbacks.map((feedback) => (
                        <tr key={feedback._id}>
                            <td>{feedback.name}</td>
                            <td>{feedback.achievement}</td>
                            <td className="admin-studentfeedback-feedback-text">{feedback.feedbackText}</td>
                            <td className="admin-studentfeedback-actions">
                                <button
                                    onClick={() => handleEdit(feedback)}
                                    className="admin-studentfeedback-edit-button"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(feedback._id)}
                                    className="admin-studentfeedback-delete-button"
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default StudentFeedbacks;